/* eslint-disable object-shorthand */
let GoogleReCaptchaURL;
const RECAPTCHA_V3 = window.config.RECAPTCHA_V3;
const RECAPTCHA_ACTIONS = {
    Login: 'login',
    Signup: 'signup',
    CheckEmail: 'checkemail'
};

function GoogleCaptchaV3Service($q, resourceInjector, settingsService, Restangular) {
    this._api = Restangular.one('ValidateGoogleCaptcha');
    this.resourceInjector = resourceInjector;
    this.$q = $q;
    this.settingsService = settingsService;
    this.settingsService
        .getSettingValue('GoogleReCaptcha', 'GoogleReCaptchaURL')
        .then(function (setting) {
             GoogleReCaptchaURL = setting;
        });
    this.ReCaptchaActions = RECAPTCHA_ACTIONS;
}

GoogleCaptchaV3Service.prototype.load = function () {
    const deferred = this.$q.defer();
    const scriptUrl = `${GoogleReCaptchaURL}?render=${RECAPTCHA_V3}`;

    if (this.resourceInjector.isScriptInjected(scriptUrl)) {
        if (window.grecaptcha) {
            deferred.resolve(window.grecaptcha);
        } else {
            this.resourceInjector.removeHeadSrcInjection(scriptUrl);
            this.resourceInjector
                .injectScript(scriptUrl)
                .then(() => {
                    deferred.resolve(window.grecaptcha);
                });
        }
    } else {
        window.grecaptcha = null;

        this.resourceInjector.injectScript(scriptUrl)
            .then(() => {
                deferred.resolve(window.grecaptcha);
            });
    }

    return deferred.promise;
};

GoogleCaptchaV3Service.prototype.execute = function (action = 'submit') {
    const deferred = this.$q.defer();

    this.settingsService
        .getSettingValue('GoogleReCaptcha', 'EnableGoogleReCaptchaV3')
        .then((showReCaptcha) => {
            if (!showReCaptcha) {
                deferred.resolve();
                return;
            }

            this.load()
                .then((grecaptcha) => {
                    grecaptcha.ready(() => {
                        grecaptcha
                            .execute(RECAPTCHA_V3, { action })
                            .then(deferred.resolve)
                            .catch(deferred.reject);
                    });
                })
                .catch(() => {
                    deferred.reject('Oops! something went wrong. Please try again.');
                });
        });

    return deferred.promise;
};

GoogleCaptchaV3Service.prototype.validateToken = function (token) {
    const deferred = this.$q.defer();

    this._api.doPOST({ GoogleReCaptchaResponse: token, Version: 'v3' })
        .then(function (response) {
            if (response.Success) {
                deferred.resolve(response);
            } else {
                deferred.reject(response);
            }
        })
        .catch(() => {
            deferred.reject('Oops! something went wrong. Please try again.');
        });

    return deferred.promise;
};

GoogleCaptchaV3Service.prototype.getToken = function (opt) {
    if (!window.grecaptcha) {
        return Promise.resolve('');
    }
    const option = opt || {};
    const {
        action,
        recaptchaKey
    } = option;

    const key = recaptchaKey || window.config.RECAPTCHA_V3 || '';

    return window.grecaptcha.execute(
        key,
        {
            action: action || ''
        }
    );
};

module.exports = GoogleCaptchaV3Service;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/googlecaptcha/googlecaptcha-v3-service.js
 **/